import { useSelector } from 'react-redux'

import { RootState } from '@/core/store'

/**
 * Hook to check if auth is initialized and get user data from Redux
 * This hook no longer fetches data - it only reads from the Redux store
 * User data is fetched once at app initialization via useAuthInitializer
 */
export const useInitializeAuth = () => {
	const { user, token, isAuthenticated } = useSelector(
		(state: RootState) => state.auth
	)

	// Auth is initialized when:
	// 1. We have no token (user is not logged in) - initialized
	// 2. We have a token and user data - initialized
	const isInitialized = !token || !!user

	return {
		isInitialized,
		isLoading: !isInitialized,
		user,
		isAuthenticated,
	}
}

export default useInitializeAuth
